<template>
  <div>
    <!-- Modal Biểu phí trả góp đề xuất  -->
    <div
      class="modal fade"
      id="bieuphi-thanhtoan"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Biểu phí thanh toán</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div class="table-price table-responsive text-center">
              <table class="table table-striped table-bordered f12">
                <thead>
                  <tr class="bg-head1">
                    <th style="width: 50px"><b>STT</b></th>
                    <th><b>Loại thẻ/Phương thức thanh toán</b></th>
                    <th class="txt-center"><b>Mức phí</b></th>
                  </tr>
                </thead>
                <tbody v-for="(item, index) in dataTariff" :key="index">
                  <tr>
                    <td class="txt-center">{{ index + 1 }}</td>
                    <td>{{ item.issuerName }}/{{ item.paymentMethod }}</td>
                    <td class="txt-center">
                      <span v-if="item.isDefaultFee === false" style="background: yellow">
                        <b>{{ item.feePerTransaction }} %</b>
                      </span>
                      <span v-else
                        ><b>{{ item.feePerTransaction }} %</b></span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
              <p class="f14"><b>Lưu ý: </b></p>
              <ol class="form-style2 f12 text-left">
                <li><i>Đơn vị tính là VNĐ và đã bao gồm VAT.</i></li>
                <li>
                  <i
                    >Biểu phí này căn cứ theo chính sách của Bên A được ban hành tại từng thời
                    điểm.</i
                  >
                </li>
              </ol>
            </div>
          </div>
          <!-- <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-dismiss="modal">Xác nhận</button>
                            <a href="#" class="btn btn-primary" data-dismiss="modal">Xác nhận</a>
                            <a href="#lydo-tuchoiduyet" class="btn btn-danger" data-dismiss="modal" data-toggle="modal">Từ chối</a>
                        </div> -->
        </div>
      </div>
    </div>
    <!-- Modal Biểu phí trả góp đề xuất  -->
    <div
      class="modal fade"
      id="bieuphi-dexuat"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Biểu phí trả góp</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div class="table-price table-responsive text-center">
              <table class="table table-striped table-bordered f12">
                <tr>
                  <th rowspan="2" width="86px">Ngân hàng</th>
                  <th colspan="6" class="text-center">Kỳ trả góp ( tháng )</th>
                </tr>
                <tr>
                  <th class="text-center">03</th>
                  <th class="text-center">06</th>
                  <th class="text-center">09</th>
                  <th class="text-center">12</th>
                  <th class="text-center">18</th>
                  <th class="text-center">24</th>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Sacombank</p>
                  </td>
                  <td class="text-center">
                    <span class="old-price">2%</span>
                    <strong class="new-price"> 2%</strong>
                  </td>
                  <td class="text-center">
                    <span class="old-price">3,9%</span>
                    <strong class="new-price"> 3,9%</strong>
                  </td>
                  <td class="text-center">
                    <span class="old-price">4,9%</span>
                    <strong class="new-price"> 4,9%</strong>
                  </td>
                  <td class="text-center">
                    <span class="old-price">5,9%</span>
                    <strong class="new-price"> 5,9%</strong>
                  </td>
                  <td class="text-center">--</td>
                  <td class="text-center">--</td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>HSBC</p>
                  </td>
                  <td class="text-center">
                    <span class="old-price">2%</span>
                    <strong class="new-price"> 2%</strong>
                  </td>
                  <td class="text-center">
                    <span class="old-price">3,9%</span>
                    <strong class="new-price"> 3,9%</strong>
                  </td>
                  <td class="text-center">
                    <span class="old-price">4,9%</span>
                    <strong class="new-price"> 4,9%</strong>
                  </td>
                  <td class="text-center">
                    <span class="old-price">5,9%</span>
                    <strong class="new-price"> 5,9%</strong>
                  </td>
                  <td class="text-center">--</td>
                  <td class="text-center">--</td>
                </tr>
              </table>
            </div>
          </div>
          <!-- <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-dismiss="modal">Xác nhận</button>
                            <a href="#" class="btn btn-primary" data-dismiss="modal">Xác nhận</a>
                            <a href="#lydo-tuchoiduyet" class="btn btn-danger" data-dismiss="modal" data-toggle="modal">Từ chối</a>
                        </div> -->
        </div>
      </div>
    </div>
    <!-- Modal Biểu phí trả góp mặc định  -->
    <div
      class="modal fade"
      id="bieuphi-tragop"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Biểu phí trả góp</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <div class="table-price table-responsive text-center">
              <table class="table table-striped table-bordered f12">
                <tr>
                  <th rowspan="2" width="86px">Ngân hàng</th>
                  <th colspan="6" class="text-center">Kỳ trả góp ( tháng )</th>
                </tr>
                <tr>
                  <th class="text-center">03</th>
                  <th class="text-center">06</th>
                  <th class="text-center">09</th>
                  <th class="text-center">12</th>
                  <th class="text-center">18</th>
                  <th class="text-center">24</th>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Sacombank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center">--</td>
                  <td class="text-center">--</td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>HSBC</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Shinhan</p>
                  </td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>VIB</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Eximbank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">6,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Maritimebank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>VPB</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">7,9%</td>
                  <td class="text-center">8,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Teckcombank</p>
                  </td>
                  <td class="text-center">--</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">--</td>
                  <td class="text-center">6,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Citibank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Seabank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Standard Chartered</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>SCB</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">6,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>SHB</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center">8,5%</td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>BIDV</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <!-- <tr>
                                        <td class="text-center">
                                            <span><img src="assets/img/favicon/Logo NH Merchant-17.png" alt=""></span><br />
                                            <p>Nam Á</p>
                                        </td>
                                        <td class="text-center"><i>--</i></td>
                                        <td class="text-center">3,9%</td>
                                        <td class="text-center"><i>--</i></td>
                                        <td class="text-center">5,9%</td>
                                        <td class="text-center"><i>--</i></td>
                                        <td class="text-center"><i>--</i>

                                        </td>
                                    </tr> -->
                <tr>
                  <td class="text-center">
                    <p>FeCredit</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>OCB</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Kiên Long</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">6,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>TP Bank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Vietcombank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">6,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <!-- <tr>
                                        <td class="text-center">
                                            <span><img src="assets/img/favicon/Logo NH Merchant-28.png" alt=""></span><br />
                                            <p>Vietinbank</p>
                                        </td>
                                        <td class="text-center">2%</td>
                                        <td class="text-center">3,9%</td>
                                        <td class="text-center">4,9%</td>
                                        <td class="text-center">6,9%</td>
                                        <td class="text-center"><i>--</i></td>
                                        <td class="text-center"><i>--</i>

                                        </td>
                                    </tr> -->
                <tr>
                  <td class="text-center">
                    <p>MBbank</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>ACB</p>
                  </td>
                  <td class="text-center">2%</td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">4,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
                <tr>
                  <td class="text-center">
                    <p>Home Credit</p>
                  </td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center">3,9%</td>
                  <td class="text-center">5,9%</td>
                  <td class="text-center">6,9%</td>
                  <td class="text-center"><i>--</i></td>
                  <td class="text-center"><i>--</i></td>
                </tr>
              </table>
            </div>
          </div>
          <!-- <div class="modal-footer">
                            <button type="button" class="btn btn-light" data-dismiss="modal">Xác nhận</button>
                            <a href="#" class="btn btn-primary" data-dismiss="modal">Xác nhận</a>
                            <a href="#lydo-tuchoiduyet" class="btn btn-danger" data-dismiss="modal" data-toggle="modal">Từ chối</a>
                        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        dataTariff: [],
      }
    },
  }
</script>

<style scoped></style>
